import styled from 'styled-components';
import { Button, DatePicker, Row, Select } from 'antd';
import { H1 } from 'components/common/typography/H1/H1';
import { H2 } from 'components/common/typography/H2/H2';

export const Title = styled(H1)`
  color: var(--status-info-text-color) !important;
  margin-bottom: 1rem !important;
  margin-top: 1rem;
  font-size: 2rem !important;
  text-align: center;
`;

export const Subtitle = styled(H2)`
  margin-top: 1rem;
  font-size: 1.5rem !important;
  margin-bottom: 1rem !important;
`;

export const TableOptionButton = styled(Button)`
  background-color: var(--brand-primary-color) !important;
  color: var(--text-on-brand-color);
  font-size: 20px;
  height: 40px;
  border-color: var(--border-subtle-color);
  box-shadow: var(--shadow-elevated);
  :hover {
    color: var(--text-on-brand-color) !important;
    border-color: var(--brand-primary-hover-color) !important;
    background-color: var(--brand-primary-hover-color) !important;
  }
`;

export const PrimaryButton = styled(Button)`
  background-color: var(--warning-color);
  color: var(--text-on-light-color);
  font-size: 18px;
  font-weight: bold;
  height: 40px;
  border-color: var(--status-warning-border-color);
  box-shadow: var(--shadow-elevated);
  margin-bottom: 1.5rem;
  margin-top: 1rem;
  width: 100%;
  :hover {
    color: var(--text-on-light-color) !important;
    border-color: var(--brand-primary-color) !important;
  }
`;

export const divider = styled.hr`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

export const SubmitButton = styled(Button)`  
		text-align: center;
		background-color: var(--brand-primary-color);
		color: var(--text-on-brand-color);
		display: inline-block;
		font-size: 18px;
		font-weight: bold;
		height: 40px;
		min-width: 200px:
		border-color: var(--border-subtle-color);
		box-shadow: var(--shadow-elevated);
		margin-bottom: 1.5rem;
		margin-top: 1rem;        
		width: 100%;    
    :hover {
			color: var(--text-on-brand-color) !important;
			border-color: var(--brand-primary-hover-color) !important;
			background-color: var(--brand-primary-hover-color) !important;
    }
`;

export const SimpleSelect = styled(Select)`
  width: 100%;
`;

export const LightGreyText = styled.p`
  color: var(--text-muted-color);
`;

export const LargeDatePicker = styled(DatePicker)`
  width: 100%;
`;

export const SpacedRow = styled(Row)`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const SpacedRow50PX = styled(Row)`
  margin-top: 50px;
  margin-bottom: 50px;
`;
